<mat-accordion class="management-accordion">
    <mat-expansion-panel [expanded]="displayMode === DisplayMode.List" [disabled]="true" [ngClass]="{ expanded: displayMode === DisplayMode.Form }" hideToggle class="panel-list">
        <mat-expansion-panel-header
            [ngClass]="{ 'events-inactive': !context?.formContext.formVisible, 'events-active': context?.formContext.formVisible }"
            collapsedHeight="48px"
            expandedHeight="48px"
            class="detail-header">
            <app-list-header
                [createRight]="displayAddbuttom"
                titleText="Rôles"
                createIconText="Ajouter un rôle"
                importDatasourceName="roles"
                (created)="onRoleCreated()"
                (exported)="onRolesExported()"
                (imported)="onRolesImported()"
                (helped)="onRolesHelped()"></app-list-header>
        </mat-expansion-panel-header>

        <app-roles-list
            #itemsList
            (itemSelected)="onRoleSelected($event)"
            (itemDisplayed)="onRoleDisplayed($event)"
            (itemEdited)="onRoleEdited($event)"
            (itemDeleted)="onRoleDeleted($event)"></app-roles-list>
    </mat-expansion-panel>

    @if (displayMode === DisplayMode.Form) {
        <mat-expansion-panel [disabled]="!context?.formContext.formVisible" [expanded]="displayMode === DisplayMode.Form" [disabled]="true" hideToggle class="panel-form">
            <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px" class="detail-header">
                <app-detail-header
                    [editRight]="displayEditbuttom"
                    [formMode]="context?.formMode"
                    [displayName]="context?.formContext.item.getDisplayName()"
                    [id]="context?.formContext.item.id"
                    (displayed)="onRoleDisplayed(context?.formContext.item)"
                    (edited)="onRoleEdited(context?.formContext.item)"
                    (helped)="onRolesHelped()"
                    (backToList)="onBackToList()"></app-detail-header>
            </mat-expansion-panel-header>
            <app-role-detail
                [context]="context"
                (roleUpdated)="onRoleUpdated($event)"
                (roleRightsUpdated)="onRoleRightsUpdated($event)"
                (roleRightsImported)="onRoleRightsImported($event)"
                (canceled)="onBackToList()"></app-role-detail>
        </mat-expansion-panel>
    }
</mat-accordion>
